export default __webpack_public_path__ + "static/simon2-ffe3c7b9f074d42e19334cdcbd3f8917.webp";